import React from "react";
import { useSpring, animated as a } from "react-spring";

export function FadeInAndShrink(props) {
	const anim = useSpring({
		from: { opacity: 0, transform: "scale(1.05)", height: "100%" },
		to: { opacity: 1, transform: "scale(1)" },
		delay: props.delay ? props.delay : 0,
		config: { duration: props.duration ? props.duration : undefined }
	});

	return <a.div style={anim}>{props.children}</a.div>;
}

export function FadeUp(props) {
	const anim = useSpring({
		from: { opacity: 0, marginTop: 30 },
		to: { opacity: 1, marginTop: 0 },
		delay: props.delay ? props.delay : 0,
		config: { duration: props.duration ? props.duration : undefined }
	});

	return <a.div style={anim}>{props.children}</a.div>;
}

export function GrowToFullSize(props) {
	const anim = useSpring({
		from: { opacity: 0, transform: "scale(0.01)" },
		to: { opacity: 1, transform: "scale(1)" },
		delay: props.delay ? props.delay : 0,
		config: { duration: props.duration ? props.duration : undefined }
	});

	return <a.div style={anim}>{props.children}</a.div>;
}

export function SlideInFromLeft(props) {
	const anim = useSpring({
		from: { opacity: 0, marginLeft: -30 },
		to: { opacity: 1, marginLeft: 0 },
		delay: props.delay ? props.delay : 0,
		config: { duration: props.duration ? props.duration : undefined }
	});

	return <a.div style={anim}>{props.children}</a.div>;
}

export function SlideInFromRight(props) {
	const anim = useSpring({
		from: { opacity: 0, marginLeft: 30 },
		to: { opacity: 1, marginLeft: 0 },
		delay: props.delay ? props.delay : 0,
		config: { duration: props.duration ? props.duration : undefined }
	});

	return <a.div style={anim}>{props.children}</a.div>;
}
